import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { CourseOptionFilterType } from '../../../constants';
import { CourseOptionDisplayModuleContext } from '../../../context';
import {
  Icon,
  OverflowVisible,
  StyledTableLayout,
} from '../../../styledComponents';
import { TableHeader } from '../TableHeader';
import { TableInteractiveHeader } from '../TableInteractiveHeader';
import { TableRow } from '../TableRow';

export function Table() {
  const { t } = useTranslation();
  const {
    rows,
    filters,
    section: {
      showSettings: {
        showDate,
        showLanguage,
        showDownloadBrochureLink,
        showTrainers,
      },
    },
  } = useContext(CourseOptionDisplayModuleContext);

  const showLanguageColumn = showLanguage || showDownloadBrochureLink;
  const deliveryTypeFilter = filters[CourseOptionFilterType.DELIVERY_TYPE];
  const languageFilter = filters[CourseOptionFilterType.LANGUAGE];
  const currencyFilter = filters[CourseOptionFilterType.CURRENCY];

  return (
    <OverflowVisible>
      <StyledTableLayout>
        <table>
          <thead>
            <tr>
              {showDate && (
                <th>
                  <TableHeader
                    label={t(
                      'site.modules.course-option-display.table.header.date.label',
                    )}
                    icon={<Icon matIcon="schedule" outlined />}
                  />
                </th>
              )}
              <th>
                {deliveryTypeFilter.shown ? (
                  <TableInteractiveHeader
                    filterKey={CourseOptionFilterType.DELIVERY_TYPE}
                    options={deliveryTypeFilter.options}
                    label={t(
                      'site.modules.course-option-display.table.header.delivery-type.label',
                    )}
                    icon={<Icon matIcon="maps_home_work" outlined />}
                  />
                ) : (
                  <TableHeader
                    label={t(
                      'site.modules.course-option-display.table.header.delivery-type.label',
                    )}
                    icon={<Icon matIcon="maps_home_work" outlined />}
                  />
                )}
              </th>
              {showTrainers && (
                <th>
                  <TableHeader
                    label={t(
                      'site.modules.course-option-display.table.header.trainer.label',
                    )}
                    icon={<Icon matIcon="person" outlined />}
                  />
                </th>
              )}
              {showLanguageColumn && (
                <th>
                  {languageFilter.shown ? (
                    <TableInteractiveHeader
                      filterKey={CourseOptionFilterType.LANGUAGE}
                      options={languageFilter.options}
                      label={t(
                        'site.modules.course-option-display.table.header.language.label',
                      )}
                      icon={<Icon matIcon="maps_home_work" outlined />}
                    />
                  ) : (
                    <TableHeader
                      label={t(
                        'site.modules.course-option-display.table.header.language.label',
                      )}
                      icon={<Icon matIcon="language" outlined />}
                    />
                  )}
                </th>
              )}
              <th>
                {currencyFilter.shown && (
                  <TableInteractiveHeader
                    filterKey={CourseOptionFilterType.CURRENCY}
                    options={currencyFilter.options}
                    label={t(
                      'site.modules.course-option-display.table.header.currency.label',
                    )}
                    icon={<Icon matIcon="attach_money" />}
                    alignRight
                  />
                )}
              </th>
              <th />
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <TableRow row={row} key={index} />
            ))}
          </tbody>
        </table>
      </StyledTableLayout>
    </OverflowVisible>
  );
}
